<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";
import moment from "moment";
import DatePicker from "vue2-datepicker";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, DatePicker },
    data() {
        return {
            title: "Evento-Laborantes",
            items: [
                {
                text: "Eventos",
                href: "/"
                },
                {
                text: "Agregar Laborantes",
                active: true
                }
            ],
            evento:'',
            eventoid_seleccion:{},
            laborantes:[],
            status:'',
            apoyo:[
                {
                    laborante:[],
                    hora_inicio:'',
                    hora_fin:'',
                }
            ],
            relator:[
                {
                    laborante:'',
                    evento:'',
                    hora_inicio:'',
                    hora_fin:'',
                    fecha:'',
                    tipo:'Relator'
                }
            ],
            laborante:null,
            apoyo_pagado:[],
            relator_pagado:[],
            liquido:0,
            tipos:[],
            subtipos:[],
        };
    },
    watch:{
        // Observar cambios en el array completo
        apoyo: {
            handler() {
                this.verificarCampos_apoyo();
            },
            deep: true // Para detectar cambios en los objetos dentro del array
        },
        relator: {
            handler() {
                this.verificarCampos_relator();
            },
            deep: true // Para detectar cambios en los objetos dentro del array
        }
    },
    methods:{
        verificarCampos_apoyo() {
            this.apoyo.forEach((lab, index) => {
                if (lab.laborante && lab.hora_inicio && lab.hora_fin) {
                    const laborante_id = lab.laborante.id || lab.laborante_id;
                    if (!laborante_id) {
                        this.msg('error', 'Error: El laborante seleccionado no tiene ID.');
                        return;
                    }
                    const formData = new FormData();
                    formData.append('laborante_id', laborante_id);
                    formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
                    formData.append('hora_inicio', lab.hora_inicio);
                    formData.append('hora_fin', lab.hora_fin);
                    axios.post('/api/revisar_choque_horario_laborante', formData).then(response => {
                        if (!response.data.estado) {
                            this.msg('error', 'El laborante ya tiene horas asignadas en este horario.');
                            console.log('El laborante ya tiene horas asignadas en este horario.');
                            lab.hora_inicio = '';
                            lab.hora_fin = '';
                        }
                    })
                    .catch(() => {
                        this.msg('error', 'Error al verificar choque de horario.');
                        console.log('Error al verificar choque de horario.');
                        
                    });
                }
            });
        },
        verificarCampos_relator() {
            this.relator.forEach((lab, index) => {
                if (lab.laborante && lab.hora_inicio && lab.hora_fin) {
                    const laborante_id = lab.laborante.id || lab.laborante_id;
                    if (!laborante_id) {
                        this.msg('error', 'Error: El laborante seleccionado no tiene ID.');
                        return;
                    }
                    const formData = new FormData();
                    formData.append('laborante_id', laborante_id);
                    formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
                    formData.append('hora_inicio', lab.hora_inicio);
                    formData.append('hora_fin', lab.hora_fin);
                    axios.post('/api/revisar_choque_horario_laborante', formData).then(response => {
                        if (!response.data.estado) {
                            this.msg('error', 'El laborante ya tiene horas asignadas en este horario.');
                            console.log('El laborante ya tiene horas asignadas en este horario.');
                            lab.hora_inicio = '';
                            lab.hora_fin = '';
                        }
                    })
                    .catch(() => {
                        this.msg('error', 'Error al verificar choque de horario.');
                        console.log('Error al verificar choque de horario.');
                        
                    });
                }
            });
        },
        labelselect_laborante ({ name }) {
            return `${name}`
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        agregar_lab_apoyo(){
            let a={
                laborante:[],
                hora_inicio:'',
                hora_fin:'',
            };
            this.apoyo.push(a);
        },
        eliminar_apoyo(index){
            this.apoyo.splice(index, 1);
        },
        guardar_apoyo(){
            if (this.apoyo.length==0) {
                this.msg('error','No hay laborantes para agregar');
                return
            }
            //elimino los laborantes vacios
            this.apoyo.forEach(element => {
                if(element.laborante.length==0 && element.hora_inicio=='' && element.hora_fin==''){
                    var indice = this.apoyo.indexOf(element); // obtenemos el indice
                    this.apoyo.splice(indice, 1); // 1 es la cantidad de elemento a eliminar
                }
            });
            let formData = new FormData();
            formData.append('apoyo', JSON.stringify(this.apoyo));
            formData.append('evento_id', this.eventoid_seleccion.id);
            formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
            axios.post('/api/guardar_laborantes_apoyo', formData).then(response => {
                this.actualizar()
                this.msg('success','Se han guardado los laborantes de apoyo.');
            });
            
        },
        agregar_lab_relator(){
            let a={
                laborante:[],
                hora_inicio:'',
                hora_fin:'',
            };
            this.relator.push(a);
        },
        eliminar_relator(index){
            this.relator.splice(index, 1);
        },
        guardar_relator(){
            if (this.relator.length==0) {
                this.msg('error','No hay laborantes para agregar');
                return
            }
            //elimino los laborantes vacios
            this.relator.forEach(element => {
                if(element.laborante.length==0 && element.hora_inicio=='' && element.hora_fin==''){
                    var indice = this.apoyo.indexOf(element); // obtenemos el indice
                    this.relator.splice(indice, 1); // 1 es la cantidad de elemento a eliminar
                }
            });
            let formData = new FormData();
            formData.append('relator', JSON.stringify(this.relator));
            formData.append('evento_id', this.eventoid_seleccion.id);
            formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
            axios.post('/api/guardar_laborantes_relator', formData).then(response => {
                this.actualizar()
                this.msg('success','Se han guardado laborantes relator.');
            });
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        obtenerLabotante(element){
            let laborante = this.laborantes.filter((us) => us.id==element);
            if (laborante.length>0) {
                return laborante[0];
            }
        },
        actualizar(){
            axios.get(`/api/get_laborantes_evento/${this.eventoid_seleccion.codigo}`).then(response => {
                //this.apoyo= response.data.apoyo;
                this.relator=[];
                this.apoyo=[];
                if(this.apoyo.length==0){
                    this.agregar_lab_apoyo();
                }
                if(this.relator.length==0){
                    this.agregar_lab_relator();
                }
                if (this.user.rol=='Admin') {
                    this.apoyo_pagado= response.data.apoyo_pagado;
                    this.relator_pagado= response.data.relator_pagado;
                    console.log(this.apoyo_pagado);
                    console.log(this.relator_pagado);
                    
                }else if(this.user.rol=='Supervisor'){
                    this.apoyo_pagado= response.data.apoyo_pagado.filter((us) => obtenerLabotante(us.laborante_id).sede == this.user.sede);
                    this.relator_pagado= response.data.relator_pagado.filter((us) => obtenerLabotante(us.laborante_id).sede == this.user.sede);
                }else{
                    this.apoyo_pagado= response.data.apoyo_pagado.filter((us) => us.user_id == this.user.id);
                    this.relator_pagado= response.data.relator_pagado.filter((us) => us.user_id == this.user.id);
                }
            });
        },
        valorpago(lab){
            axios.get('/api/get_pagos_periodo/'+lab.id).then(response => {
                this.liquido = response.data.total_liquido
                if (this.liquido>=250000) {
                    Swal.fire({
                        //position: "top-end",
                        icon: 'warning',
                        title: 'Laborante alcanzó limite de $250.000 en periodo '+this.formatFecha(response.data.inicio)+' al '+this.formatFecha(response.data.fin) ,
                        text: 'Tener en consideración para próximas actividades.',
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#C87838"
                        //showConfirmButton: false,
                        //timer: 5000
                    });
                }
            });
        }
    },
    mounted(){
        axios.get('/api/get_laborantes').then(response => {
            if (this.user.rol=='Admin') {
                this.laborantes= response.data.usuarios;
            }else {
                this.laborantes= response.data.usuarios.filter((us) => us.sede==this.user.sede);
            }
        });
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos
            this.subtipos=res.data.subtipos
        });
    },
    created(){
        if (localStorage.getItem("evento_codigo")) {
            const evento = localStorage.getItem("evento_codigo");
            this.evento=evento;//JSON.parse(evento);
            localStorage.removeItem("evento_codigo");
            axios.get(`/api/get_evento/${evento}`).then(response => {
                if(response.data.estado){
                    this.eventoid_seleccion=response.data.evento;
                    axios.get(`/api/get_laborantes_evento/${this.eventoid_seleccion.codigo}`).then(response => {
                        //this.apoyo= response.data.apoyo;
                        if(this.apoyo.length==0){
                            this.agregar_lab_apoyo();
                        }
                        if(this.relator.length==0){
                            this.agregar_lab_relator();
                        }
                        if (this.user.rol=='Admin') {
                            this.apoyo_pagado= response.data.apoyo_pagado;
                            this.relator_pagado= response.data.relator_pagado;
                        }else if(this.user.rol=='Supervisor'){
                            this.apoyo_pagado= response.data.apoyo_pagado.filter((us) => obtenerLabotante(us.laborante_id).sede == this.user.sede);
                            this.relator_pagado= response.data.relator_pagado.filter((us) => obtenerLabotante(us.laborante_id).sede == this.user.sede);
                        }else{
                            this.apoyo_pagado= response.data.apoyo_pagado.filter((us) => us.user_id == this.user.id);
                            this.relator_pagado= response.data.relator_pagado.filter((us) => us.user_id == this.user.id);
                        }
                    });
                }
            });
        }else{
            window.location.href = "/web/configuracion/eventosiniciados";
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card mt-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <h1 class="text-primary mb-4">{{ eventoid_seleccion.nombre_difusion }}</h1>
                                <h3 class="text-primary mb-4">{{ eventoid_seleccion.colegio }}</h3>
                            </div>
                            <div class="col-md-6">
                                <p class="font-size-16"><strong>Actividad:</strong> {{ eventoid_seleccion.nombre_difusion }}</p>
                                <p class="font-size-16"><strong>Código:</strong> {{ eventoid_seleccion.codigo }}</p>
                                <p class="font-size-16"><strong>Fecha Inicio:</strong> {{ eventoid_seleccion.fecha_inicio }}</p><!--con hora -->
                                <p class="font-size-16"><strong>Fecha de término:</strong> {{ eventoid_seleccion.fecha_termino }}</p>
                                <p class="font-size-16"><strong>Tipo:</strong> {{ tipos.find((us)=> us.codigo==eventoid_seleccion.tipo_codigo).nombre }}</p>
                                <p class="font-size-16"><strong>SubTipo:</strong> {{ subtipos.find((us)=> us.codigo==eventoid_seleccion.subtipo_codigo).nombre }}</p>
                            </div>
                            <div class="col-md-6">
                                <p class="font-size-16"><strong>Nombre para Difusión Digital:</strong> {{ eventoid_seleccion.nombre_difusion }}</p>
                                <p class="font-size-16"><strong>Sede Asociada:</strong> {{ eventoid_seleccion.sede_asociada }}</p>
                                <p class="font-size-16"><strong>Cantidad Inscripciones:</strong> {{ eventoid_seleccion.cantidad_inscripciones }}</p>
                                <p class="font-size-16"><strong>Nº Asistentes:</strong> {{ eventoid_seleccion.num_asistentes }}</p>
                                <p class="font-size-16"><strong>Propietario:</strong> {{ eventoid_seleccion.propietario }}</p>
                                
                            </div>
                            <div class="offset-md-1 col-md-10 shadow-sm">
                                <h5 class="text-primary mb-4">Agregar Laborantes Apoyo: </h5>
                                <div class="row" v-for="(lab,index) in apoyo" :key="index">
                                    <div class="col-md-4">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Laborante:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <multiselect
                                                    v-model="lab.laborante"
                                                    :options="laborantes" 
                                                    placeholder="Seleccionar laborante" 
                                                    selectLabel="Presiona para seleccionar"
                                                    selectedLabel="Seleccionado"
                                                    deselectLabel="Presiona para remover"
                                                    :custom-label="labelselect_laborante"
                                                    @select="valorpago"
                                                    >
                                                    <template v-slot:noOptions>
                                                        <p>No hay opciones</p>
                                                    </template>
                                                    <template v-slot:noResult>
                                                        <p>No se encuentra coincidencia</p>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Hora inicio:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.hora_inicio" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Hora fin:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.hora_fin" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <br>
                                        <b-button variant="danger" class="mt-2" @click="eliminar_apoyo(index)"><i class="bx bx-trash"></i></b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="offset-md-6 col-md-6 text-right mb-3">
                                        <b-button class="" variant="primary" @click="agregar_lab_apoyo"><i class="bx bx-plus"></i>Laborante</b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <b-button variant="primary" block @click="guardar_apoyo()">Guardar Laborantes de Apoyo</b-button>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="offset-md-1 col-md-10">
                                <div class="row">
                                    <div class="col-md-6 mt-4">
                                        <b-form-checkbox id="checkbox-1" v-model="status" name="checkbox-1" > Relator </b-form-checkbox>
                                    </div>
                                </div>
                            </div>
                            <div class="offset-md-1 col-md-10 mt-3 shadow-sm" v-if="status">
                                <h5 class="text-primary mb-4">Agregar Relator: </h5>
                                <div class="row" v-for="(lab,index) in relator" :key="index">
                                    <div class="col-md-4">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Laborante:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <multiselect
                                                    v-model="lab.laborante"
                                                    :options="laborantes" 
                                                    placeholder="Seleccionar laborante" 
                                                    selectLabel="Presiona para seleccionar"
                                                    selectedLabel="Seleccionado"
                                                    deselectLabel="Presiona para remover"
                                                    :custom-label="labelselect_laborante"
                                                    >
                                                    <template v-slot:noOptions>
                                                        <p>No hay opciones</p>
                                                    </template>
                                                    <template v-slot:noResult>
                                                        <p>No se encuentra coincidencia</p>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Hora inicio:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.hora_inicio" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Hora fin:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.hora_fin" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <br>
                                        <b-button variant="danger" class="mt-2" @click="eliminar_relator(index)"><i class="bx bx-trash"></i></b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="offset-md-6 col-md-6 text-right mb-3">
                                        <b-button class="" variant="primary" @click="agregar_lab_relator"><i class="bx bx-plus"></i>Laborante</b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <b-button variant="primary" block @click="guardar_relator()">Guardar Relator(es)</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3" v-if="apoyo_pagado.length>0 || relator_pagado.length>0">
                            <div class="col-md-12">
                                <h5 class="text-primary mb-4">Laborantes ya agregados</h5>
                                <div class="table-responsive mb-0 mt-3">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th style="width: 20%;">Nombre</th>
                                                <th style="width: 10%;">RUT</th>
                                                <th style="width: 10%;">Sede</th>
                                                <th style="width: 10%;">Tipo</th>
                                                <th style="width: 10%;">Fecha</th>
                                                <th style="width: 10%;">Hora inicio</th>
                                                <th style="width: 10%;">Hora fin</th>
                                                <!-- <th style="width: 20%;">Acción</th> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in apoyo_pagado" :key="index">
                                                <td>{{ obtenerLabotante(item.laborante_id).name }}</td>
                                                <td>{{ obtenerLabotante(item.laborante_id).rut }}</td>
                                                <td>{{ obtenerLabotante(item.laborante_id).sede }}</td>
                                                <td>{{ item.tipo_laborante }}</td>
                                                <td>{{ formatFecha(item.fecha) }}</td>
                                                <td>{{ item.hora_inicio }}</td>
                                                <td>{{ item.hora_fin }}</td>
                                                <!-- <td>
                                                    
                                                </td> -->
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr v-for="(item, index) in relator_pagado" :key="index">
                                                <td>{{ obtenerLabotante(item.laborante_id).name }}</td>
                                                <td>{{ obtenerLabotante(item.laborante_id).rut }}</td>
                                                <td>{{ obtenerLabotante(item.laborante_id).sede }}</td>
                                                <td>{{ item.tipo_laborante }}</td>
                                                <td>{{ formatFecha(item.fecha) }}</td>
                                                <td>{{ item.hora_inicio }}</td>
                                                <td>{{ item.hora_fin }}</td>
                                                <!-- <td>
                                                    
                                                </td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>